var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.9971,
    cy: 27.002,
    r: 27.002,
    fill: "#B5BCC8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4263 14.1433H20.5682C17.0175 14.1433 14.1392 17.0217 14.1392 20.5723V33.4304C14.1392 36.9811 17.0175 39.8595 20.5682 39.8595H33.4263C36.9769 39.8595 39.8553 36.9811 39.8553 33.4304V20.5723C39.8553 17.0217 36.9769 14.1433 33.4263 14.1433Z",
    stroke: "#FCFCFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1401 26.1911C32.2987 27.2612 32.116 28.354 31.6178 29.3141C31.1196 30.2743 30.3313 31.0529 29.3651 31.5392C28.3988 32.0255 27.3039 32.1948 26.2359 32.023C25.1679 31.8511 24.1813 31.3469 23.4164 30.582C22.6516 29.8171 22.1473 28.8305 21.9755 27.7625C21.8036 26.6946 21.9729 25.5996 22.4592 24.6334C22.9456 23.6671 23.7242 22.8789 24.6843 22.3807C25.6445 21.8825 26.7373 21.6997 27.8073 21.8584C28.8987 22.0202 29.9092 22.5288 30.6894 23.309C31.4696 24.0892 31.9782 25.0997 32.1401 26.1911Z",
    stroke: "#FCFCFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0693 19.9297H34.0811",
    stroke: "#FCFCFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/insta-icon.018362cd0c61dc05c77f8a75fa34839c.svg";
export { ForwardRef as ReactComponent };